import React, { useState, useEffect, useReducer } from 'react';

export const UserContext = React.createContext();

const initialState = {
  isAuthenticated: false,
  user:  localStorage.getItem('user')? JSON.parse(localStorage.getItem('user')):null,
  preToken:  localStorage.getItem('preToken')
};
const reducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      localStorage.setItem('user', JSON.stringify(action.payload));
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        token: action.payload.token,
      };
    case 'PRE_LOGIN':
      localStorage.setItem('preToken', action.payload.preToken);
      return {
        ...state,
        preToken: action.payload.preToken,
      };
    case 'LOGOUT':
      localStorage.clear();
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        preToken: null,
      };
    default:
      return state;
  }
};

export const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = {state, dispatch, user:state.user, isAuth:!!state.isAuthenticated}
  
  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => React.useContext(UserContext);
